'use client';

import React, { Component } from 'react';
import './style.sass';

import Customer from '../reusable-components/layouts-components__adventureLand/customer';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import Results from '../reusable-components/layouts-components__adventureLand/results';
import Review from '../reusable-components/layouts-components__common-cases/review';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import Directions from '../reusable-components/layouts-components__adventureLand/directions';

import Accelerator from '../reusable-components/layouts-components__adventureLand/accelerator';
import Startups from '../reusable-components/layouts-components__adventureLand/startups';
import Investors from '../reusable-components/layouts-components__adventureLand/investors';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';

const skolkovoMainTitle = {
    titleMainText: 'Продвижение сообщества AdventureLand Технопарка «Сколково» на венчурном рынке',
    titleAnimation: '/images/pic/preview/AdventureLand.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#c1d028',
            nameText: 'Технопарк «Сколково»',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#c1d028',
            nameText: 'Технологии',
        },
        {
            modeText: 'Услуги',
            colorMode: '#c1d028',
            nameText: 'Perfomance-маркетинг, редизайн сайта',
        },
    ],
};

const reviewSkolkovo = {
    reviewText:
        'Было очень трудно найти специалистов по маркетингу, которые разбираются в нашей специфике. Для того чтобы продвигать наш проект, команда Вебпрактик быстро погрузилась в тему венчурных инвестиций (а это сплав науки, финансов и стартапов) и помогла нам выйти на качественно новый уровень коммуникации с аудиторией.',
    reviewAuthors: [
        {
            title: 'Мария Иванова',
            subtitle: 'Руководитель Skolkovo Adventureland',
            img: '/images/svg/skolkovo/Ivanova.jpg',
        },
    ],
    isBlank: true,
    link: 'https://www.facebook.com/masha.yves',
};

const nextProjectSkolkovo = {
    nextProjectTitle: 'Миссия невыполнима: 8&nbsp;месяцев, 12&nbsp;продуктов, 100% KPI',
    nextProjectImg: '/images/pic/preview/skolkovo.png',
    nextProjectLink: '/cases/marketing/skolkovo',
    nextProjectLinkTitle: 'Технопарк «Сколково»',
    nextProjectText:
        'Это самый большой Технопарк Европы, а&nbsp;также место и&nbsp;сервис поддержки и&nbsp;развития для инновационных компаний.',
};

class AdventureLand extends Component {
    render() {
        return (
            <section className="skolkovo">
                <MainTitle MainTitle={skolkovoMainTitle} />

                <Customer />

                <Directions />

                <Accelerator />

                <Startups />

                <Investors />

                <Results />

                <Review Review={reviewSkolkovo} />
                <ScrollAnimation>
                    <FullWrapper>
                        <OfferButton linkText="Нанять Команду" />
                    </FullWrapper>
                </ScrollAnimation>

                <NextProject NextProject={nextProjectSkolkovo} />
            </section>
        );
    }
}

export default AdventureLand;
